import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/pro-solid-svg-icons/faChevronDown";
import { ExportType, ExportTypes } from "~/modules/downloads/types";
import {
    faDownload,
    faFile,
    faFileExcel,
} from "@fortawesome/pro-regular-svg-icons";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from "~/components/ui/dropdown-menu";
import { Button } from "~/components/ui/button";

// // // //

/**
 * ExportDropdown
 * Renders a dropdown for generating CSV + Excel exports
 */
export function ExportDropdown(props: {
    disabled: boolean;
    onExport: (exportType: ExportType) => void;
}) {
    const { onExport, disabled } = props;

    // return (
    //     <DownloadButton
    //         disabled={disabled}
    //         onClick={() => {
    //             onExport(ExportTypes.csv);
    //         }}
    //     />
    // );

    return (
        <DropdownMenu>
            <Button
                asChild
                disabled={disabled}
                variant="outline"
                className="shadow-sm border-muted-foreground"
                size="xs"
            >
                <DropdownMenuTrigger disabled={disabled}>
                    <FontAwesomeIcon icon={faDownload} aria-hidden="true" />
                    Download Data
                    <FontAwesomeIcon
                        icon={faChevronDown}
                        className="ml-1 h-3 w-3"
                        aria-hidden="true"
                    />
                </DropdownMenuTrigger>
            </Button>
            <DropdownMenuContent className="w-56 z-200" align="end">
                <DropdownMenuItem
                    onClick={() => {
                        onExport(ExportTypes.csv);
                    }}
                    className="group cursor-pointer text-slate-800 text-sm px-4 py-2 focus:bg-slate-50"
                >
                    <FontAwesomeIcon
                        icon={faFile}
                        className="h-5 w-5 text-slate-400 group-hover:text-slate-500"
                        aria-hidden="true"
                    />
                    CSV
                </DropdownMenuItem>
                <DropdownMenuItem
                    onClick={() => {
                        onExport(ExportTypes.excel);
                    }}
                    className="group cursor-pointer text-slate-800 text-sm px-4 py-2 focus:bg-slate-50"
                >
                    <FontAwesomeIcon
                        icon={faFileExcel}
                        className="h-5 w-5 text-slate-400 group-hover:text-slate-500"
                        aria-hidden="true"
                    />
                    Excel
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
